import { debounceTime, Observable, Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { ArrowBackComponent } from 'app/modules/GlobalComponents/arrow-back.component';
import { AtributosBienCulturalService } from './atributos-bien-cultural.service';
import { ValoresBienCulturalResponse } from '../../models/atributos.model';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'atributos-bien-cultural',
    templateUrl: 'atributos-bien-cultural.component.html',
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,

        //componentes
        ArrowBackComponent,
        HasPermissionsDirective,

    ]
})

export class AtributosBienCulturalComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(MatPaginator) paginator!: MatPaginator;

    searchControl: UntypedFormControl = new UntypedFormControl();
    atributosTableColumns: string[] = ['numero', 'nombre-del-campo', 'uso', 'descripcion'];

    datosOriginales: any[] = [];
    dataSource: any[] = [];

    totalResultItems = 0;
    pageSize = 10;

    private destroy$ = new Subject<void>();

    constructor(private atributosBienCulturalService: AtributosBienCulturalService) {}

    ngOnInit(): void {
        this.atributosBienCulturalService.getAtributos();

        this.atributosBienCulturalService.atributos$
            .pipe(takeUntil(this.destroy$))
            .subscribe(response => {
                this.datosOriginales = response.data || [];
                this.totalResultItems = this.datosOriginales.length;


                this.actualizarTabla();
            });

        this.searchControl.valueChanges
            .pipe(debounceTime(300), takeUntil(this.destroy$))
            .subscribe(() => {
                if (this.paginator) this.paginator.firstPage();
                this.actualizarTabla();
            });
    }

    ngAfterViewInit(): void {
        this.paginator.page
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.actualizarTabla();
            });
    }

    actualizarTabla(): void {
        const filtro = this.searchControl.value?.toLowerCase() || '';

        const filtrados = this.datosOriginales.filter(item =>
            item.campoNombre?.toLowerCase().includes(filtro) ||
            item.descripcion?.toLowerCase().includes(filtro) ||
            item.aplicacion?.toLowerCase().includes(filtro)
        );

        this.totalResultItems = filtrados.length;

        const startIndex = this.paginator.pageIndex * this.pageSize;
        this.dataSource = filtrados.slice(startIndex, startIndex + this.pageSize);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
